import AlertsContext, {
  AlertsState as AlertsState_,
  provideAlerts,
  withAlerts,
} from './context';

export default AlertsContext;
export type AlertsState = AlertsState_;
export { provideAlerts, withAlerts };
